import type {
  CollaborationResponse,
  EngineeringFindingState,
  EngineeringFindingKind,
  EngineeringFindingsResponse,
} from "@insights/contracts";
import { api } from "../api-client";

export type EngineeringFindingsFilters = {
  kind?: EngineeringFindingKind | "";
  repository: string;
  teamId: string;
  state: "active" | EngineeringFindingState | "all";
};

function queryString(filters: EngineeringFindingsFilters) {
  const query = new URLSearchParams({ state: filters.state });
  if (filters.kind) query.set("kind", filters.kind);
  if (filters.repository) query.set("repository", filters.repository);
  if (filters.teamId) query.set("teamId", filters.teamId);
  return query.toString();
}

export function getCollaboration(
  workspaceId: string,
  filters: Pick<EngineeringFindingsFilters, "repository" | "teamId">,
) {
  const query = new URLSearchParams();
  if (filters.repository) query.set("repository", filters.repository);
  if (filters.teamId) query.set("teamId", filters.teamId);
  const suffix = query.size ? `?${query.toString()}` : "";
  return api<CollaborationResponse>(`/${workspaceId}/collaboration${suffix}`);
}

export function getEngineeringFindings(
  workspaceId: string,
  filters: EngineeringFindingsFilters,
) {
  return api<EngineeringFindingsResponse>(
    `/${workspaceId}/findings?${queryString(filters)}`,
  );
}

export function updateEngineeringFinding(
  workspaceId: string,
  findingId: string,
  state: EngineeringFindingState,
  dismissalReason?: string | null,
) {
  return api<void>(`/${workspaceId}/findings/${encodeURIComponent(findingId)}`, {
    method: "PATCH",
    body: JSON.stringify({ state, dismissalReason }),
  });
}

export function engineeringFindingEvidenceOpened(
  workspaceId: string,
  findingId: string,
) {
  return api<void>(
    `/${workspaceId}/findings/${encodeURIComponent(findingId)}/evidence-opened`,
    { method: "POST" },
  );
}
